import type { Handler } from './handler';
import type { ApiFetchCuratedEventsPort } from './ports/api-fetch-curated-events.port';
import type {
  CuratedEvent,
  FetchCuratedEventsParams,
} from '~/types/curated-events';
import { tryCatch } from '~/utils/apostatudo/try-catch';
import { resolveAdapter } from '~/adapters/registry';

export const fetchCuratedEventsHandler: Handler<Params, Ports, Result> = async (
  params,
  ports = {
    apiFetchCuratedEvents: resolveAdapter('apiFetchCuratedEvents'),
  },
) => {
  const [events, fetchError] = await tryCatch(
    ports?.apiFetchCuratedEvents.handle(params),
  );

  if (fetchError) {
    console.error(
      '[fetchCuratedEventsHandler] ❌ Erro ao buscar curated events:',
      fetchError,
    );

    return { events: null };
  }

  return { events };
};

type Params = FetchCuratedEventsParams | undefined;

type Ports = { apiFetchCuratedEvents: ApiFetchCuratedEventsPort };

type Result = Promise<{ events: CuratedEvent[] | null }>;
